// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1d8f7381","186":"44f828a1","225":"fc4f5d6c","272":"222846bb","372":"cc522b69","377":"a9c4082f","738":"ca84261d","841":"c879a9a4","856":"d09e9a6b","994":"0d88a892"}[chunkId] + ".chunk.js";
};